// /src/components/mdm/routes.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import DataManagement from "../../components/mdm/components/dataManagement";
import { useQueryClient } from "@tanstack/react-query";

function MdmRouter() {
  const queryClient = useQueryClient();

  return (
    <div
      className="reports-router-div"
      style={{
        display: "flex",
        flexDirection: "column",
        paddingTop: "42px",
        height: "100%",
        width: "100%",
        paddingLeft: "10px",
        paddingRight: "10px",
      }}
    >
      <Routes>
        <Route path="/" element={<Navigate to="dataManagement" replace />} />
        <Route path="dataManagement/*" element={<DataManagement queryClient={queryClient} />} />
      </Routes>
    </div>
  );
}

export default MdmRouter;
